import type { FC } from 'react';

import { Carousel, CarouselContent } from '@wwe-portal/ui/components/carousel';

import { FlagshipPagination } from './flagship-pagination';

export const FlagshipSliderLayout: FC<{
  children: React.ReactNode;
  hasPagination?: boolean;
}> = ({ children, hasPagination = true }) => {
  return (
    <Carousel
      className="w-full md:overflow-hidden"
      opts={{ startIndex: 0, loop: true, containScroll: 'trimSnaps' }}
    >
      <CarouselContent
        className="ml-0 mr-0 pl-0 md:mr-0"
        containerClassName="md:overflow-hidden rounded-[10px]"
      >
        {children}
      </CarouselContent>
      {hasPagination && (
        <div className="-mt-5 mb-3 w-full md:mt-1">
          <FlagshipPagination duplication={1} />
        </div>
      )}
    </Carousel>
  );
};
